import { Component, input } from '@angular/core';
import { LineInputs } from '@charts';
import { LineChartComponent } from "../line-chart";

@Component({
  selector: 'ui-tsabt-temperature-chart',
  imports: [LineChartComponent],
  template: ` <ui-line-chart [lineInputs]="lineInputs()" /> `,
})
export class TsabtTemperatureChartComponent {
  lineInputs = input.required<LineInputs>();
}
